import React from 'react';
import { motion } from 'framer-motion';

const Gallery = () => {
  const images = [
    'https://i.postimg.cc/CMNLHbY4/2026-10-05-11-20-29.jpg',
    'https://i.postimg.cc/G3QhJvd1/2026-10-05-11-20-32.jpg',
    'https://i.postimg.cc/CMNLHbSS/2026-10-05-11-20-34.jpg',
    'https://i.postimg.cc/T29Yqnf6/2026-10-05-11-20-36.jpg',
    'https://i.postimg.cc/Wpnb60jH/2026-10-05-11-20-38.jpg',
    'https://i.postimg.cc/HskWSjsq/2026-10-05-11-20-40.jpg',
    'https://i.postimg.cc/153RW45b/2026-10-05-11-20-42.jpg'
  ];

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-brandOrange font-bold tracking-wider uppercase text-sm mb-2">
            Success Stories
          </h2>
          <h3 className="text-4xl font-extrabold text-royal">Join Our Wall of Fame</h3>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Nothing makes us happier than seeing our students pass with flying colors. You could be next!
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {images.map((src, index) => (
            <motion.div
              key={src}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group overflow-hidden rounded-xl shadow-md aspect-[4/5]"
            >
              <img
                src={src}
                alt={`Happy driving student ${index + 1}`}
                className="w-full h-full object-cover object-right transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-royal/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                <span className="text-white font-bold text-lg">Passed! 🎉</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;